import { render } from "./AmountCol.vue?vue&type=template&id=2269d87f"
import script from "./AmountCol.vue?vue&type=script&lang=js"
export * from "./AmountCol.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__